import { render } from "./StoragesEditComponent.vue?vue&type=template&id=12d4a730&ts=true"
import script from "./StoragesEditComponent.vue?vue&type=script&lang=ts"
export * from "./StoragesEditComponent.vue?vue&type=script&lang=ts"

import "./StoragesEditComponent.vue?vue&type=style&index=0&id=12d4a730&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QBtn,QInput,QIcon,QMenu,QCardSection,QAvatar,QCardActions,QTooltip,QDialog});qInstall(script, 'directives', {ClosePopup});
